/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeAutoObservable, runInAction } from "mobx";
import { Basket, Order } from "../../../types/product";
import http from "../../../libs/http";

class BasketStore {

    basket: Basket[] = JSON.parse(localStorage.getItem('basket') || "[]");

    isLoading: boolean = false;

    isLoadingPrices: boolean = false;


    constructor() {
        makeAutoObservable(this);
    }


    addToBasket(product: Basket) {
      runInAction(() => {
          // Ищем продукт с таким же ref_key и warehouse
          const existingProductIndex = this.basket.findIndex(
              item => item.product.ref_key === product.product.ref_key && 
                     item.warehouse === product.warehouse
          );
  
          if (existingProductIndex !== -1) {
              // Если продукт найден - увеличиваем количество
              this.basket[existingProductIndex].quantity += product.quantity;
          } else {
              // Если продукт не найден - добавляем новый
              this.basket.push(product);
          }
      });
      
      // Обновляем localStorage
      localStorage.setItem('basket', JSON.stringify(this.basket));
  }

    clearBasket() {
        runInAction(() => {
            this.basket = [];
        });
        localStorage.setItem('basket', JSON.stringify(this.basket));
    }

    updateQuantity(refKey: string, warehouse: string, newQuantity: number) {
        const item = this.basket.find(
          (i) => i.product.ref_key === refKey && i.warehouse === warehouse
        );
        
        if (item) {
          if (newQuantity <= 0) {
            // Удалить товар, если количество 0 или меньше
            this.basket = this.basket.filter(
              (i) => !(i.product.ref_key === refKey && i.warehouse === warehouse)
            );
          } else {
            item.quantity = newQuantity;
          }
        }
        localStorage.setItem('basket', JSON.stringify(this.basket));
      }
    
      // Получить общую сумму заказа
      get totalSum() {
        return this.basket.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
      }
    
      // Получить общее количество товаров
      get totalItems() {
        const uniqueItems = new Set<string>();

        this.basket.forEach(item => {
            const itemKey = `${item.product.ref_key}_${item.warehouse}`;
            uniqueItems.add(itemKey);
        });

        return uniqueItems.size;
      }

      get uniqueWarehousesCount() {
        const warehouses = new Set<string>();
        this.basket.forEach(item => warehouses.add(item.warehouse));
        return warehouses.size;
      }

     async createOrder(order: Order) {
        this.startLoading();
         const { data } = await http.post('api/order/create', order)
        this.finishLoading();
         return data;

      }

      startLoading() {
        runInAction(() => {
            this.isLoading = true
        })
    }

    finishLoading() {
        runInAction(() => {
            this.isLoading = false
        })
    }

    startLoadingPrices() {
        runInAction(() => {
            this.isLoadingPrices = true
        })
      }

      finishLoadingPrices() {
        runInAction(() => {
            this.isLoadingPrices = false
        })
      }

    async updatePrices() 
    {
      this.startLoadingPrices();

      const refKeys = this.basket.map((i) => i.product.ref_key);

      const { data } = await http.post<{ ref_key: string; price: number }[]>(
        'api/products/prices',
        {
          products: refKeys
        }
      );
      runInAction(() => { });
      data.forEach((priceInfo) => {
        const item = this.basket.find(
          (i) => i.product.ref_key === priceInfo.ref_key
        );
        if (item) {
          item.product.price = priceInfo.price;
        }
      });

      localStorage.setItem('basket', JSON.stringify(this.basket));

      this.finishLoadingPrices();
    }
}

export default new BasketStore();